export const PAGE_SIZE = 5;
export const columnsWidth = {
  readingType: 393,
  assign: 172,
};
